import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetSweetShopArticleByUidApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        slug: z.string(),
        name: z.string(),
        description: z.any(),
        weight: z.number().optional().nullable(),
        price: z.number().optional().nullable(),
        images: z.array(
            z.object({
                url: z.string(),
            }),
        ).optional().nullable(),
        currency: z.object({
            name: z.string(),
            abbreviation: z.string(),
        }).optional().nullable(),
        category: z.object({
            name: z.string(),
            documentId: z.string(),
            slug: z.string(),
        }).optional().nullable(),
        tags: z.array(
            z.object({
                name: z.string(),
            }),
        ).optional().nullable(),
        elements: z.array(
            z.object({
                name: z.string(),
                value: z.number(),
                meassure: z.string(),
            }),
        ).optional().nullable(),
        recommendations: z.array(
            z.object({
                documentId: z.string(),
                slug: z.string(),
                name: z.string(),
                weight: z.number().optional().nullable(),
                price: z.number().optional().nullable(),
                images: z.array(
                    z.object({
                        url: z.string(),
                    }),
                ).optional().nullable(),
                currency: z.object({
                    name: z.string(),
                    abbreviation: z.string(),
                }).optional().nullable(),
            }),
        ).optional().nullable(),
    }),
});

type GetSweetShopArticleByUidApiResponse
    = ApiResponse<z.infer<typeof GetSweetShopArticleByUidApiResponseSchema>>
    | BaseError;

type GetSweetShopArticleByUidActionRequest = {
    uid: string,
}

export const getSweetShopArticleByUid = createAsyncThunk<
    GetSweetShopArticleByUidApiResponse,
    GetSweetShopArticleByUidActionRequest
>(
    'SweetShopArticlePageActionsGetSweetShopArticleByUid',
    async ({
        uid,
    }) => apiInstance.get(
        `/s/sweet-shop-articles/${uid}`,
        {
            'fields[0]': '*',
            'populate[images][fields]': 'url',
            'populate[currency][fields]': '*',
            'populate[category][fields]': '*',
            'populate[tags][fields]': '*',
        },
        GetSweetShopArticleByUidApiResponseSchema,
    ),
);
